var _mask, _g, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69065 0.200195H2.30965C1.01889 0.217774 -0.0141577 1.27666 0.000146778 2.56746V17.8329C-0.0141577 19.1237 1.01889 20.1826 2.30965 20.2002H9.02353V19.1934H11.0166V20.1976H12.0001V2.56746C12.0145 1.27666 10.9814 0.217774 9.69065 0.200195ZM10.9977 15.2174H0.989707V4.20785H10.9977V15.2174Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 -1.7998H-6V22.2002H18V-1.7998Z",
    fill: "#0E5AA7"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 12,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03396 16.2097V17.807C1.03324 18.5739 1.65352 19.1965 2.42038 19.1988H11.0143V16.2115L1.03396 16.2097ZM7.01967 17.1999V18.1968H5.01306V17.1999H7.01967ZM9.70687 1.18237C10.4737 1.18461 11.094 1.80728 11.0933 2.57414V3.18727H0.939454V2.57414C0.938729 1.80728 1.55901 1.1846 2.32587 1.18237H9.70687Z",
    fill: "#F3F6F8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18 -1.7998H-6V22.2002H18V-1.7998Z",
    fill: "#F3F6F8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.701f19ad5b9f389398a4eca685d2780b.svg";
export { ForwardRef as ReactComponent };